import HardwareVersionsPage from './hardware-versions-page';

export default HardwareVersionsPage;